module.exports = __webpack_public_path__ + "static/media/ic-real-estate-simple.47c14eb6.svg";